module.exports = __webpack_public_path__ + "static/media/ari_logo.dad0beb5.svg";